<template>
  <v-card
    v-bind:class="{ archived: paragraph.archived, hidden: (!viewArchived && paragraph.archived) }"
    style="margin-bottom:20px;"
  >
    <FormTemplateFieldSelector
      :templateID="$route.params.id"
      v-if="!loading && fieldSelecting"
      @select="fieldSelecting = false;editparagraph.conditional_question_id = arguments[0].question_id; editparagraph.conditional_fieldtype_id = arguments[0].fieldtype_id"
      @cancel="fieldSelecting = false"
    />
    <v-toolbar
      dense
      flat
      color="rgba(0,0,0,0.09)"
      style="position:relative;"
    >
        <a
          roll="button"
          class="handle"
          style="float:left;"
        >
          <v-icon small left>drag_handle</v-icon>
        </a>
        <b style="margin-right: 50px;">Paragraph</b>
        <div v-if="!editing">
          <v-chip 
            outline
            color="grey"
            small
            v-if="conditional_part"  
          >
            Conditional
          </v-chip>
          <v-chip 
            outline
            color="grey"
            small
            v-if="paragraph.web_only"  
          >
            Web Only
          </v-chip>
          <v-chip 
            outline
            color="grey"
            small
            v-if="paragraph.pdf_only"  
          >
            PDF Only
          </v-chip>
        </div>
        <ArchiveButton
          style="float:right;position:absolute;right:45px;top:12px;"
          :archived="paragraph.archived"
          @restore="restore()"
          @archive="archive()"
        />
        <a
          roll="button"
          class="question-edit-button"
          style="float:right;position:absolute;right:15px;top:12px;"
          @click="editing=true"
        >
          <v-icon small color="blue">edit</v-icon>
        </a>
        <div style="float:right;position:absolute;top:0px;right:5px;">
            <v-btn
              v-if="editing"
              color="blue"
              dark
              small
              @click="save"
            >
              Save
            </v-btn>
            <v-btn
              v-if="editing"
              small
              @click="editing=false;editHTML=false"
            >
              Cancel
            </v-btn>
        </div>
    </v-toolbar>
    <div style="position:relative;padding:15px;">
      <Preloader v-if="loading"/>
      <div
        v-if="!editing"
        class="html"
        v-on:dblclick="editing = true"
        v-html="paragraph.text"
      >
      </div>
      <Editor
        :enable_html="true"
        :enable_formatting='editparagraph.web_only'
        v-if="editing"
        ref="htmlEditor"
        :html="editparagraph.text"
        @editingHTML="(val) => editHTML = val"
      />
    </div>
    <div
      v-if="editing"
      style="position: relative;min-height: 30px;background: rgba(0,0,0,0.02);"
    >
      <div
        class="adv_settings"
      >
        <span
          @click="displayAdditional=!displayAdditional"
        >
          <v-icon
            style="line-height: inherit;vertical-align: unset;padding-right: 10px;"
            size="18"
          >
            {{ displayAdditional ? 'mdi-chevron-up-circle' : 'mdi-chevron-down-circle' }}
          </v-icon>
          Additional Settings
        </span>
        <v-expand-transition>
          <div
            v-show="displayAdditional"
            style="padding: 10px 0 15px 0;"
          >
            <v-checkbox
              v-model="editparagraph.web_only"
              label="Hide on PDF (Web Only)"
            />
            <v-flex xs12 sm3>
              <v-checkbox
                v-model="editparagraph.pdf_only"
                label="PDF Only"
                persistent-hint
                hint="Do not show on Web"
              />
            </v-flex>
            <v-flex xs12 sm3>
              <v-checkbox
                v-model="conditional_part"
                label="Conditional Form Part"
                persistent-hint
                hint="Display part depending on answer to question"
              />
            </v-flex>
            <v-layout 
              row 
              wrap 
              v-if="conditional_part"
            >
              <v-flex xs12 sm3>
                <v-text-field
                  v-model="editparagraph.conditional_question_id"
                  label="Question ID"
                  style="margin-right: 10px;"
                  disabled
                />
              </v-flex>
              <v-flex xs12 sm3>
                <v-text-field
                v-model="editparagraph.conditional_fieldtype_id"
                  label="Fieldtype ID"
                  style="margin-right: 10px;"
                  disabled
                />
              </v-flex>
              <v-flex xs12 sm3>
                <v-text-field
                  v-model="editparagraph.conditional_value"
                  label="Conditional Value"
                  style="margin-right: 10px;"
                />
              </v-flex>
              <v-flex xs12 sm3>
                <v-checkbox
                  v-model="editparagraph.conditional_apply_pdf"
                  label="Apply to PDF"
                  persistent-hint
                  hint="Hide from PDF if part fails condition"
                />
              </v-flex>
              <v-flex sm 12>
                <v-btn
                  dense
                  @click="fieldSelecting = true"
                >
                  Select a field
                </v-btn>
              </v-flex>
            </v-layout>
          </div>
        </v-expand-transition>
      </div>
    </div>
  </v-card>
</template>

<script>
import { mapGetters, mapActions, mapState } from 'vuex'
import Preloader from '@/components/global/Preloader'
import Editor from '@/components/admin/Editor'
import ArchiveButton from './ArchiveButton'
import FormTemplateFieldSelector from '../FormTemplateFieldSelector.vue'

export default {
  name: 'FormTemplateParagraph',
  props: [ 'partId', 'newPart' ],
  components: {
    Preloader,
    Editor,
    ArchiveButton,
    FormTemplateFieldSelector
  },
  data () {
    return {
      editparagraph: {},
      editing: false,
      loading: false,
      displayAdditional: false,
      value: '',
      editHTML: false,
      conditional_part: false,
      fieldSelecting: false
    }
  },
  created () {
    this.editing = !(this.paragraph.id)
    this.conditional_part = (this.paragraph.conditional_question_id)
  },
  computed: {
    ...mapGetters('formtemplate', [
      'partById',
      'fieldTypeById'
    ]),
    ...mapState('formtemplate', [
      'viewArchived'
    ]),
    paragraph: function () {
      return this.partById(this.partId) || this.newPart
    },
  },
  watch: {
    editing (val) {
      if (val) {
        this.editparagraph = JSON.parse(JSON.stringify(this.paragraph))
      } else {
        this.$emit('cancel')
      }
    }
  },
  methods: {
    ...mapActions('formtemplate', [
      'saveParagraph'
    ]),
    save () {
      this.loading = true
      this.editparagraph.text = this.$refs.htmlEditor.getHTML()
      if(!this.conditional_part){
        this.editparagraph.conditional_question_id = null
        this.editparagraph.conditional_fieldtype_id = null
        this.editparagraph.conditional_apply_pdf = false
        this.editparagraph.conditional_value = ""
      }
      if (!this.editHTML){
        this.editparagraph.text = this.$refs.htmlEditor.getHTML().replace(/<p>/g, "").replace(/<\/p>/g, "<br>").replace(/(<br>*)$/,'')
      }
      this.saveParagraph(this.editparagraph)
      .then(paragraph => {
        this.editing = false
        this.$emit('save', paragraph)
        this.loading = false
        this.editHTML = false
      })
    },
    archive () {
      this.loading = true
      this.paragraph.archived = true
      this.saveParagraph(this.paragraph)
      .then(paragraph => {
        this.loading = false
        this.$emit('save', paragraph)
      })
    },
    restore () {
      this.loading = true
      this.paragraph.archived = false
      this.saveParagraph(this.paragraph)
      .then(paragraph => {
        this.loading = false
        this.$emit('save', paragraph)
      })
    }
  }
}
</script>

<style scoped>
  .html >>> p {
    margin: 0 !important;
  }

  .adv_settings {
      padding:0 10px;
      padding: 0 25px 0 25px;
      border-top: 1px solid rgba(0,0,0,0.1)
  }

  .hidden {
    display: none !important;
  }

</style>